import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import ENV from '../config/environment';
import type IntlService from 'ember-intl/services/intl';
import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import type LoggingService from '../services/logger';

class HelpItem {
  topic = '';

  constructor(topic: string, intl: IntlService, site: SiteService) {
    this.topic = topic;
    this.intl = intl;
    this.site = site;
  }
  get isFromUrl() {
    return this.topic[0] === '@';
  }
  get title() {
    let key = this.topic;
    if (this.topic[0] === '@') {
      key = this.topic.slice(1);
    }
    const result = this.intl.t(`help.${key}.title`, { htmlSafe: true });
    return result ? result : '';
  }
  get url() {
    if (this.topic[0] === '@') {
      return `${ENV.rootURL}helptext/${this.site.FullLocale}/${this.topic.slice(1)}.html`;
    } else {
      return '';
    }
  }
  get message() {
    const key = this.topic;
    if (this.topic[0] === '@') {
      return '';
    } else {
      const result = this.intl.t(`help.${key}.message`, { htmlSafe: true });
      return result ? result : '';
    }
  }
}

export default class HelpitemHelper extends Helper {
  @service declare intl: IntlService;
  @service('aditools-site') declare siteconfig: SiteService;
  @service declare logger: LoggingService;
  compute(params: string[]): HelpItem {
    let topic = '';
    if (params[0]) {
      topic = params[0];
    } else {
      this.logger.warn(`Help topic is undefined...`);
    }
    return new HelpItem(topic, this.intl, this.siteconfig);
  }
}
